export const GOOGLE_BASE_URL = 'https://maps.googleapis.com/maps/api';
export const GOOGLE_KEY = 'AIzaSyCgH_4wIYbnvSWFhsEYPZrI02Y05rcGw34';
